/**
 * Tab Tareas del Panel de Internal — Kanban de proyectos/tareas del equipo
 * (modelo de timeflow). El drawer vive acá para sobrevivir al cambio de
 * sub-tab y abrirse desde cualquier vista.
 */
import { useCallback, useState } from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useTasksBoard } from '@/hooks/useInternalTasks';
import { LoaderBlock, EmptyState } from '../shared';
import { BoardView } from './BoardView';
import { ProjectsView } from './ProjectsView';
import { TaskDrawer } from './TaskDrawer';
import { useTranslation } from 'react-i18next';

export function TasksTab() {
  const { t } = useTranslation();
  const { data, isLoading, error } = useTasksBoard();
  const [view, setView] = useState<'board' | 'projects'>('board');
  const [selectedTaskId, setSelectedTaskId] = useState<string | null>(null);
  const closeDrawer = useCallback(() => setSelectedTaskId(null), []);

  if (isLoading) return <LoaderBlock />;
  if (error || !data) return <EmptyState title={t('internal.taskstab.no_se_pudieron_cargar_las_tareas')} description={error?.message} />;

  return (
    <div className="space-y-4">
      <Tabs value={view} onValueChange={(v) => setView(v as 'board' | 'projects')}>
        <TabsList>
          <TabsTrigger value="board">Tablero</TabsTrigger>
          <TabsTrigger value="projects">Proyectos</TabsTrigger>
        </TabsList>
      </Tabs>

      {view === 'board'
        ? <BoardView projects={data.projects} tasks={data.tasks} onOpenTask={setSelectedTaskId} />
        : <ProjectsView projects={data.projects} tasks={data.tasks} />}

      <TaskDrawer taskId={selectedTaskId} tasks={data.tasks} projects={data.projects} onClose={closeDrawer} />
    </div>
  );
}
